import { useStyles } from "../context";
import { CoreUiComponents, CORE_UI_NAME } from "@b2bportal/core-types";

export const useUiStyles = (
  componentName: keyof typeof CoreUiComponents,
  defaultStyles?: object
) => {
  return useStyles(CORE_UI_NAME, componentName, defaultStyles);
};
